<template>
  <div class="saved-view-menu">
    <button class="saved-view-btn" @click="toggleOpen">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" width="16" height="16">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"/>
      </svg>
      Views
    </button>
    <div v-if="isOpen" class="saved-view-dropdown">
      <div v-if="views && views.length > 0">
        <button v-for="view in views" :key="view.key" class="saved-view-option" @click="selectView(view.key)">
          <span class="view-label">{{ view.label }}</span>
          <span v-if="view.description" class="view-description">{{ view.description }}</span>
        </button>
      </div>
      <div v-else class="saved-view-empty">No saved views</div>
      <div class="saved-view-divider"></div>
      <button class="saved-view-option save-view-option" @click="saveCurrentView">Save current view</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SavedViewMenu',
  props: {
    views: { type: Array, default: function() { return []; } }
  },
  data: function() {
    return { isOpen: false };
  },
  methods: {
    toggleOpen: function() { this.isOpen = !this.isOpen; },
    selectView: function(key) {
      this.$emit('select-view', key);
      this.isOpen = false;
    },
    saveCurrentView: function() {
      this.$emit('save-view');
      this.isOpen = false;
    }
  }
};
</script>

<style scoped>
.saved-view-menu {
  position: relative;
}

.saved-view-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  color: #475569;
  border: 1px solid #cbd5e1;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 0.8125rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Inter', sans-serif;
}
.saved-view-btn:hover { background: #f1f5f9; border-color: #94a3b8; }

.saved-view-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 100;
  min-width: 220px;
}

.saved-view-option {
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: left;
  padding: 8px 16px;
  background: none;
  border: none;
  font-size: 0.8125rem;
  color: #334155;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  transition: background 0.1s;
}
.saved-view-option:hover { background: #f1f5f9; }

.view-label { font-weight: 500; }
.view-description { font-size: 0.6875rem; color: #94a3b8; margin-top: 2px; }

.saved-view-empty {
  padding: 12px 16px;
  font-size: 0.75rem;
  color: #94a3b8;
}

.saved-view-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 4px 0;
}

.save-view-option {
  color: #3b82f6;
  font-weight: 600;
}
</style>
